




























import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit } from 'vue-property-decorator';
import { validators } from '@/utils/validations';

@Component({})
export default class ChallengeTopicReport extends Vue {
  show: boolean = true;
  denounce: string = '';
  readonly rules = validators;

  @Emit()
  onConfirm() {
    this.show = false;
    return;
  }

  @Emit()
  onCancel() {
    this.show = false;
    return;
  }
}
